import { Navigate } from "react-router-dom";
import Header from "../components/site/Header";
import Footer from "../components/site/Footer";
import PageHero from "../components/site/PageHero";
import { PageSection, CheckGrid, CTABand, DisclaimerBox } from "../components/site/ContentBlocks";
import { serviceLd } from "../components/site/SEO";
import { FadeUp } from "../components/site/Reveal";
import { PRODUCT_PAGES, TRADING_DISCLAIMER } from "../data/content";

export default function ProductPage({ pid }) {
    const product = PRODUCT_PAGES.find((p) => p.id === pid);
    if (!product) return <Navigate to="/international-trading" replace />;

    return (
        <div className="grain bg-navy-deep" data-testid={`product-page-${product.id}`}>
            <Header />
            <main>
                <PageHero
                    seo={{
                        title: product.seoTitle,
                        description: product.seoDesc,
                        path: product.path,
                        jsonLd: serviceLd(product.title, product.seoDesc, product.path),
                    }}
                    crumbs={[{ label: "International Trading", href: "/international-trading" }, { label: product.crumbsLabel }]}
                    eyebrow={product.eyebrow}
                    title={product.title}
                    copy={product.intro}
                />

                <section className="bg-navy-deep pb-4">
                    <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                        <FadeUp>
                            <div className="relative overflow-hidden border border-white/8">
                                <img
                                    src={product.image}
                                    alt={product.imageAlt}
                                    loading="lazy"
                                    className="h-[280px] w-full object-cover lg:h-[400px]"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-navy-deep/70 via-transparent to-transparent" aria-hidden="true" />
                            </div>
                        </FadeUp>
                    </div>
                </section>

                <PageSection eyebrow="Coordination" title="What We Coordinate" testid={`${product.id}-points`}>
                    <CheckGrid items={product.points} cols={3} />
                </PageSection>

                <section className="bg-navy-surface py-20 lg:py-28">
                    <div className="mx-auto max-w-[1440px] space-y-10 px-5 lg:px-10">
                        <DisclaimerBox text={product.note} testid={`${product.id}-note`} />
                        <DisclaimerBox text={TRADING_DISCLAIMER} testid={`${product.id}-disclaimer`} />
                        <CTABand
                            title="Tell us your exact requirement."
                            primary={{ label: product.enquiryLabel, to: product.enquiryPath, testid: `${product.id}-enquiry-cta` }}
                            secondary={{ label: "Trading Process", to: "/trading-process", testid: `${product.id}-process-cta` }}
                        />
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
